var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCarteira(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.850098 5.70166C0.850098 3.49252 2.64096 1.70166 4.8501 1.70166H12.8501C15.0592 1.70166 16.8501 3.49252 16.8501 5.70166V11.7017C16.8501 13.9108 15.0592 15.7017 12.8501 15.7017H4.8501C2.64096 15.7017 0.850098 13.9108 0.850098 11.7017V5.70166Z",
    fill: "#FAE6E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5.70156C0 3.02298 2.17142 0.851562 4.85 0.851562H12.85C15.5286 0.851562 17.7 3.02298 17.7 5.70156V11.7016C17.7 14.3801 15.5286 16.5516 12.85 16.5516H4.85C2.17142 16.5516 0 14.3801 0 11.7016V5.70156ZM4.85 2.55156C3.1103 2.55156 1.7 3.96187 1.7 5.70156V11.7016C1.7 13.4413 3.1103 14.8516 4.85 14.8516H12.85C14.5897 14.8516 16 13.4413 16 11.7016V5.70156C16 3.96187 14.5897 2.55156 12.85 2.55156H4.85Z",
    fill: "#A51713"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8501 8.70166C14.8501 9.25394 14.4024 9.70166 13.8501 9.70166C13.2978 9.70166 12.8501 9.25394 12.8501 8.70166C12.8501 8.14938 13.2978 7.70166 13.8501 7.70166C14.4024 7.70166 14.8501 8.14938 14.8501 8.70166Z",
    fill: "#A51713"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 7.70156C10 6.12755 11.276 4.85156 12.85 4.85156H16.85C17.3194 4.85156 17.7 5.23212 17.7 5.70156V11.7016C17.7 12.171 17.3194 12.5516 16.85 12.5516H12.85C11.276 12.5516 10 11.2756 10 9.70156V7.70156ZM12.85 6.55156C12.2149 6.55156 11.7 7.06644 11.7 7.70156V9.70156C11.7 10.3367 12.2149 10.8516 12.85 10.8516H16V6.55156H12.85Z",
    fill: "#A51713"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCarteira);
export default __webpack_public_path__ + "static/media/icon_carteira.b5d3117be5569dc076134dab799e8290.svg";
export { ForwardRef as ReactComponent };